const DIGIT_BLOCKS = [0x0660, 0x06f0, 0x0966, 0x09e6, 0x0be6, 0x0e50, 0xff10];

export function toLatinDigits(value: string): string {
  let out = "";
  for (const char of value) {
    const code = char.codePointAt(0) ?? 0;
    let mapped = char;
    for (const start of DIGIT_BLOCKS) {
      if (code >= start && code <= start + 9) {
        mapped = String(code - start);
        break;
      }
    }
    out += mapped;
  }
  return out;
}
